import { DishItem } from 'models/entities/dish-item';

type Data = {
  dishItems?: DishItem[];
};

class ExportDishItemsTarget {

  readonly dishItems: DishItem[];

  constructor(data: Data = {}) {
    this.dishItems = data.dishItems ?? [];
  }

}

export { ExportDishItemsTarget };

